import React, { useState } from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { Button } from "react-bootstrap";
import GooglePlacesAutocomplete, {
	geocodeByPlaceId,
} from "react-google-places-autocomplete";
import { StaticGoogleMap, Marker } from "react-static-google-map";

import "./EventAddress.css";
//import EventMap from './EventMap';

type EventAddressData = {
	Address: string;
	Lat: string;
	Lon: string;
};

interface EventAddressProps {
	initialData: EventAddressData;
	onValueChange: (value: object) => void;
}

//export default function EventAddress(onValueChange: {}) {
const EventAddress: React.FC<EventAddressProps> = ({
	initialData,
	onValueChange,
}) => {
	const [selectedAddress, setSelectedAddress] = useState(initialData?.Address || "");
	const [mapCenter, setMapCenter] = useState({
		lat: parseFloat(initialData?.Lat || "0"),
		lng: parseFloat(initialData?.Lon || "0"),
	});
	const [showAutocomplete, setShowAutocomplete] = useState(false);
	//const map = useGoogleMap();
	const handleClick = () => {
		setShowAutocomplete(!showAutocomplete);
	};
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	const onAddressSelect = (e: any) => {
		geocodeByPlaceId(e.value.place_id)
			.then((results) => {
				setSelectedAddress(e.value.description);
				setMapCenter({
					lat: results[0].geometry.location.lat(),
					lng: results[0].geometry.location.lng(),
				});
				onValueChange({
					Name: e.value.structured_formatting.main_text,
					Address: e.value.description,
					Lat: results[0].geometry.location.lat(),
					Lon: results[0].geometry.location.lng(),
				});
			})

			.catch((error) => console.error(error));
	};

	// useEffect(() => {
	// 	console.log("Check Value", selectedAddress);
	// 	onValueChange(selectedAddress);
	// }, [selectedAddress]);

	return (
		<Container>
			<Row className="mb-3">
				<Col className="col-md-12">
					<h3>Address</h3>
				</Col>
			</Row>
			<Row className="mb-3">
				<Col className="col-md-6">
					{(selectedAddress && !showAutocomplete) && (
						<Row className="mb-3">
							<Col className="col-md-12">
								{selectedAddress}
								<Button
									className="ms-2 float-right"
									type="button"
									variant="primary"
									size="sm"
									id="show_address"
									onClick={handleClick}
								>
									Change
								</Button>
							</Col>
						</Row>
					)}
					{(!selectedAddress || showAutocomplete) && (
						<Row className="mb-3">
							<Col className="col-md-12">
								<GooglePlacesAutocomplete
									apiKey={import.meta.env.VITE_GOOGLE_MAPS_API_KEY}
									selectProps={{
										defaultInputValue: selectedAddress,
										onChange: onAddressSelect,
									}}
								/>
							</Col>
						</Row>
					)}
					{selectedAddress && (
						<StaticGoogleMap
							size="2000x400"
							className="img-responsive map-container"
							apiKey={import.meta.env.VITE_GOOGLE_MAPS_API_KEY}
						>
							<Marker location={mapCenter} label="P" />
						</StaticGoogleMap>
					)}
				</Col>
			</Row>
		</Container>
	);
};
export default EventAddress;
